import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { isNil } from 'lodash';
import {
  FiniteListMultiSelectQuestion,
  FiniteListQuestionOption
} from '../../question-types/question-finite-list-multi-select';

// TODO: Deprecate and get rid of this component
@Component({
  selector: 'ot-finite-list-multiselect-question',
  templateUrl: './finite-list-multiselect-question.component.html',
  styleUrls: ['./finite-list-multiselect-question.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FiniteListMultiselectQuestionComponent),
      multi: true
    }
  ]
})
export class FiniteListMultiselectQuestionComponent
  implements OnInit, ControlValueAccessor {
  @Input() questionFilter: FiniteListMultiSelectQuestion;
  // TODO: Never reference to the parent form
  @Input() parentForm: FormGroup;
  @Input() clearAllSelectedItemsQuestionMessage = '';
  @Output() isExpanded: EventEmitter<number> = new EventEmitter<number>();
  isClearAllItemsModalActive = false;
  isSelectedItemsModalActive = false;

  value: { key: string; value: string; checked: boolean }[];
  isDisabled: boolean;
  selectables: { key: string; value: string; checked: boolean }[];
  onChange = (_: any) => {};
  onTouch = () => {};

  ngOnInit() {
    // TODO: Don't do this, this is overriding any initial state for the question value
    this.selectAllItemsFromQuestion(this.questionFilter);
    this.parentForm.controls[this.questionFilter.key].setValue(
      this.questionFilter.selectedOptions
    );
    this.questionFilter.selectedOptions = this.sortListOfOptions(
      this.questionFilter.selectedOptions
    );
    this.questionFilter.validate();
  }

  onInput(value: any) {
    if (!isNil(value)) {
      this.value = value;
    } else {
      this.value = [];
    }
    this.onTouch();
    this.onChange(this.value);
  }

  writeValue(value: any): void {
    if (!isNil(value)) {
      this.value = value;
    } else {
      this.value = null;
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  expandListFilter(question: FiniteListMultiSelectQuestion) {
    question.isExpanded = !question.isExpanded;
    if (question.isExpanded === true) {
      question.updateCheckedValueOnOptionListWithSelectedValues();
      this.isExpanded.emit(question.order);
    }
  }

  selectOption(
    event,
    option: FiniteListQuestionOption,
    question: FiniteListMultiSelectQuestion
  ) {
    if (event.target.checked) {
      if (this.valueIsSelectAllOption(option.key)) {
        this.selectAllItemsFromQuestion(question);
        this.deActivateIndeterminateStatusOnSelectAllCheckbox();
      } else {
        question.selectedOptions.push(option);
        this.parentForm.controls[question.key].setValue(
          question.selectedOptions
        );
        if (question.selectedOptions.length === question.options.length - 1) {
          this.deActivateIndeterminateStatusOnSelectAllCheckbox();
          this.selectAllItemsFromQuestion(question);
        } else {
          this.activateIndeterminateStatusOnSelectAllCheckbox();
        }
      }
    } else {
      if (this.valueIsSelectAllOption(option.key)) {
        this.deSelectAllItemsFromQuestion(question);
      } else {
        question.selectedOptions = question.selectedOptions.filter(opt => {
          return opt.key !== option.key && opt.key !== 'All';
        });
        this.parentForm.controls[question.key].setValue(
          question.selectedOptions
        );
        if (question.selectedOptions.length === 0) {
          this.deActivateIndeterminateStatusOnSelectAllCheckbox();
        } else {
          this.activateIndeterminateStatusOnSelectAllCheckbox();
        }
      }
    }

    option.checked = event.target.checked;
    question.selectedOptions = this.sortListOfOptions(question.selectedOptions);
    question.validate();
  }

  activateIndeterminateStatusOnSelectAllCheckbox() {
    const inputValue: HTMLInputElement = <HTMLInputElement>(
      document.getElementById(
        `finite-list-option-${this.questionFilter.key}-All`
      )
    );

    inputValue.indeterminate = true;
  }

  deActivateIndeterminateStatusOnSelectAllCheckbox() {
    const inputValue: HTMLInputElement = <HTMLInputElement>(
      document.getElementById(
        `finite-list-option-${this.questionFilter.key}-All`
      )
    );

    inputValue.indeterminate = false;
  }

  sortListOfOptions(
    listToOrder: { key: string; value: string; checked: boolean }[]
  ) {
    listToOrder = listToOrder.sort((a, b) => {
      if (a.key > b.key) {
        return 1;
      }
      if (a.key < b.key) {
        return -1;
      }
    });
    return listToOrder;
  }

  valueIsSelectAllOption(stringValue: string): boolean {
    return stringValue === 'All';
  }

  selectAllItemsFromQuestion(question: FiniteListMultiSelectQuestion) {
    // TODO: No need for unselect all options if we are selecting them all right after
    this.deSelectAllItemsFromQuestion(question);
    for (const option of question.options) {
      option.checked = true;
      if (option.key !== 'All') {
        question.selectedOptions.push(option);
      }
    }
    // TODO: never override control value
    this.parentForm.controls[question.key].setValue(question.selectedOptions);
  }

  deSelectAllItemsFromQuestion(question: FiniteListMultiSelectQuestion) {
    for (const option of question.options) {
      option.checked = false;
    }
    question.selectedOptions = [];
    // TODO: never override control value
    this.parentForm.controls[question.key].setValue(question.selectedOptions);
    this.isSelectedItemsModalActive = false;
  }

  deSelectOption(optionkey: any) {
    this.updateSelectedOptions(optionkey.value);
    this.questionFilter.options.forEach(option => (option.checked = false));

    this.questionFilter.selectedOptions.forEach(option => {
      const selectedOption = this.questionFilter.options.filter(listOption => {
        return listOption.key === option.key;
      });
      selectedOption[0].checked = true;
    });
    this.questionFilter.validate();
    this.parentForm.controls[this.questionFilter.key].setValue(
      this.questionFilter.selectedOptions
    );

    if (this.questionFilter.selectedOptions.length === 0) {
      this.changeSelectedItemModalStatus();
    }
  }

  updateSelectedOptions(optionValue: string) {
    this.questionFilter.selectedOptions = this.questionFilter.selectedOptions.filter(
      entry => {
        return entry.value !== optionValue;
      }
    );
  }

  changeSelectedItemModalStatus() {
    this.isSelectedItemsModalActive = !this.isSelectedItemsModalActive;
  }

  activateClearAllItemsModalStatus() {
    this.isClearAllItemsModalActive = true;
  }

  deactivateClearAllItemsModalStatus() {
    this.isClearAllItemsModalActive = false;
  }

  deSelectAllSelectedOptions() {
    this.questionFilter.selectedOptions = [];
    this.isClearAllItemsModalActive = false;
    this.isSelectedItemsModalActive = false;
    this.questionFilter.options.forEach(option => (option.checked = false));
    this.questionFilter.validate();
  }

  toggleShowMoreStatus(question) {
    question.isShowMoreActive = !question.isShowMoreActive;
  }

  search(input: string) {
    if (input.length) {
      this.questionFilter.filteredOptions = this.questionFilter.options.filter(
        entry => {
          const pattern = new RegExp(input, 'ig');
          return pattern.test(entry.value) || entry.key === 'All';
        }
      );
    } else {
      this.questionFilter.filteredOptions = this.questionFilter.options;
    }
  }
}
